import axios, { InternalAxiosRequestConfig } from 'axios';
import { API_TIMEOUT } from '../../APIConstants';
import { getAGraphBaseUrl, getApiBaseUrlSuffix, setAGraphHeaders } from '../../utils';
import { AGraphApiSettings } from '../Base';
import { conditionalParam, isAGraphEnabled } from './AGraphUtils';
import { AW_ENTITLEMENTS_API_URL, AW_ENTITLEMENTS_API_URL_AGRAPH } from './Constants';

interface Settings extends AGraphApiSettings {
  getPkgFn?: () => string | undefined;
}
export const awEntitlementsSettings: Settings = {};

export const awEntitlementsApi = axios.create();

awEntitlementsApi.interceptors.request.use((config) => {
  const { getPkgFn, getConfigurationDirectoryFn, getAladdinApiKey, getEnvTypeFn } = awEntitlementsSettings;
  const pkg = config.params?.pkgScopeSet ?? getPkgFn?.();
  const configurationDirectory = getConfigurationDirectoryFn?.();
  const envType = getEnvTypeFn?.();

  const baseURL = isAGraphEnabled()
    ? getAGraphBaseUrl(AW_ENTITLEMENTS_API_URL_AGRAPH)
    : AW_ENTITLEMENTS_API_URL + getApiBaseUrlSuffix(envType, '-', true);

  const updatedConfig: InternalAxiosRequestConfig = {
    ...config,
    baseURL,
    timeout: API_TIMEOUT,
    params: {
      ...config.params,
      pkg: conditionalParam(config.url, 'pkg', pkg),
      configurationDirectory: conditionalParam(config.url, 'configurationDirectory', configurationDirectory),
    },
  };

  setAGraphHeaders(updatedConfig, getAladdinApiKey?.(), envType);

  return updatedConfig;
});
